import { Text, Center, Modal, ModalBody, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay, Spinner, Table, TableContainer, Tbody, Td, Th, Thead, Tr } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { CustomToast } from "../../../../components";
import { useFetch } from "../../../../hooks/useFetch";
import { format } from "date-fns/format";
import { dateTimeFormat } from "../../../../utilities/helper";

interface DirectorHistory {
    directorId: number;
    directorName: string;
    companyId: number;
    joinDate?: string;
    sharePercentage: number;
    exitDate?: string;
    created_At: string;
    created_By: string;
}

export function DirectorHistoryModal({ isOpen, onClose, companyId, companyName }: {
    isOpen: boolean;
    onClose: () => void;
    companyId: number;
    companyName: string;
}) {
    const { addToast } = CustomToast();
    const { fetchApi } = useFetch(addToast);
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState<DirectorHistory[]>([]);

    const fetchHistory = async (companyId: number) => {
        setLoading(true);
        const res = await fetchApi(`CompanyDirectorHistory/${companyId}`, "GET");
        if (res) setData(res);
        setLoading(false);
    }

    useEffect(() => {
        if (isOpen && companyId) {
            fetchHistory(companyId);
        }
    }, [isOpen, companyId]);

    return (
        <Modal isOpen={isOpen} onClose={onClose} isCentered size="5xl" scrollBehavior="inside">
            <ModalOverlay />
            <ModalContent className="font-poppins text_md text_regular">
                <ModalHeader borderBottom="1px solid #E2E8F0">
                    {companyName} - Director Change History
                </ModalHeader>
                <ModalCloseButton />
                <ModalBody py={4}>
                    {loading ? (
                        <Center py={10}>
                            <Spinner thickness="4px" speed="0.65s" emptyColor="gray.200" color="#006838" size="xl" />
                        </Center>
                    ) : data.length === 0 ? (
                        <Text textAlign="center" color="gray.500">No history found.</Text>
                    ) : (
                        <TableContainer>
                            <Table variant="simple" size="sm">
                                <Thead bg="gray.50">
                                    <Tr>
                                        {/* <Th>Director ID</Th> */}
                                        <Th>Director Name</Th>
                                        <Th>Join Date</Th>
                                        <Th>Share Percentage</Th>
                                        <Th>Exit Date</Th>
                                        <Th>Changed By</Th>
                                        <Th>Changed At</Th>
                                    </Tr>
                                </Thead>
                                <Tbody>
                                    {data.map((log, index) => (
                                        <Tr key={index} _hover={{ bg: "gray.50" }}>
                                            {/* <Td>{log.directorId}</Td> */}
                                            <Td fontWeight="500">{log.directorName}</Td>
                                            <Td>{log.joinDate ? format(log.joinDate + 'z', dateTimeFormat) : "-"}</Td>
                                            <Td>{log.sharePercentage}%</Td>
                                            <Td>{log.exitDate ? format(log.exitDate + 'z', dateTimeFormat) : "-"}</Td>
                                            <Td whiteSpace="nowrap">{log.created_By}</Td>
                                            <Td>{format(log.created_At + 'z', dateTimeFormat)}</Td>
                                        </Tr>
                                    ))}
                                </Tbody>
                            </Table>
                        </TableContainer>
                    )}
                </ModalBody>
            </ModalContent>
        </Modal>
    );
}
